import { useState } from "react";
import { Auth } from "aws-amplify";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Popover from "@mui/material/Popover";

export const AccountPopover = () => {
	const [anchorEl, setAnchorEl] = useState(null);

	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const open = Boolean(anchorEl);

	const signout = async () => {
		await Auth.signOut();
	};

	return (
		<div>
			<IconButton onClick={handleClick}>
				<AccountCircleIcon
					sx={{
						color: "white",
					}}
				/>
			</IconButton>
			<Popover
				open={open}
				anchorEl={anchorEl}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "bottom",
					horizontal: "center",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "center",
				}}
			>
				<Button onClick={signout}>Sign Out</Button>
			</Popover>
		</div>
	);
};
